<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap">
      <b-form class="d-flex align-items-center" @submit.prevent="onSearch">
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 ml-50 mt-sm-0" type="submit">
          جستجو
        </b-button>
      </b-form>
      <div class="d-flex">
        <b-button
          class="my-1 mr-50"
          variant="outline-primary"
          :to="{ name: 'add-semester' }"
        >
          ایجاد ترم
        </b-button>
        <b-button
          class="my-1"
          variant="outline-danger"
          @click="removeSemesters"
        >
          حذف ترم ها
        </b-button>
      </div>
    </div>

    <data-table
      :fields="fields"
      :items="semesters"
      :loading="loading"
      @onRowClicked="
        $router.push({ name: 'show-semester', params: { id: $event.id } })
      "
    >
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-model="removeSemestersData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #id="{ data }">
        <span> {{ data.item.id }} </span>
      </template>

      <template #name="{ data }">
        <span style="white-space: nowrap"> {{ data.item.name }}</span></template
      >
      <template #available_at="{ data }">
        <b-badge variant="light-primary">
          {{ data.item.available_at ? calcDate(data.item.available_at) : "-" }}
        </b-badge></template
      >
      <template #unavailable_at="{ data }">
        <b-badge variant="light-secondary">
          {{
            data.item.unavailable_at ? calcDate(data.item.unavailable_at) : "-"
          }}
        </b-badge>
      </template>
      <template #final_amount="{ data }">{{ finalAmount(data.item) }}</template>
      <template #course_count="{ data }">{{
        data.item.course_count || "-"
      }}</template>
      <template #separate="{ data }">
        <b-badge :variant="data.item.separate ? 'success' : 'danger'"
          >{{ data.item.separate ? "فعال" : "غیر فعال" }}
        </b-badge></template
      >
      <template #status="{ data }">
        <b-badge :variant="data.item.active ? 'light-success' : 'light-danger'"
          >{{ data.item.active ? "فعال" : "غیر فعال" }}
        </b-badge></template
      >

      <template #actions="{ data }">
        <div class="d-flex justify-content-around">
          <b-button
            size="sm"
            variant="flat-info"
            :to="{ name: 'users-semester', params: { id: data.item.id } }"
            style="white-space: nowrap"
          >
            <feather-icon icon="UsersIcon" />
            <span class="ml-50" style="white-space: nowrap"
              >مشاهده کاربران</span
            >
          </b-button>
          <b-button
            size="sm"
            variant="flat-primary"
            :to="{
              name: 'show-semester',
              params: { id: data.item.id },
            }"
            style="white-space: nowrap"
          >
            <feather-icon icon="EyeIcon" />
            <span class="ml-50">مشاهده</span>
          </b-button>
          <!-- 
          <b-button
            size="sm"
            variant="flat-primary"
            :to="{ name: 'semester-courses', params: { id: data.item.id } }"
          >
            <feather-icon icon="FileTextIcon" />
            <span class="ml-50">مشاهده دوره ها</span>
          </b-button> -->
          <b-button
            size="sm"
            variant="flat-warning"
            :to="{
              name: 'edit-semester',
              params: { id: data.item.id },
            }"
            style="white-space: nowrap"
          >
            <feather-icon icon="EditIcon" />
            <span class="ml-50">ویرایش</span>
          </b-button>

          <b-button
            size="sm"
            variant="flat-danger"
            @click="removeSemester(data.item)"
            style="white-space: nowrap"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">حذف</span>
          </b-button>
        </div>
      </template>
    </data-table>
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div>
      <div class="col-md-6 d-flex justify-content-md-center align-items-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BDropdownItem,
  BDropdown,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BCard,
    BAvatar,
    BDropdownItem,
    BDropdown,
    BFormCheckbox,
    BForm,
    BFormInput,
    BFormGroup,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      selectAll: false,
      removeSemestersData: [],
      semesters: [],
      loading: false,
      url: "",
      search: "",
      currentPage: 1,
      pagination: {},
      visible: false,
      choosenPage: 1,
      fields: [
        { key: "selectuser", label: "" },
        { key: "id", label: "شناسه" },
        { key: "name", label: "نام" },
        { key: "available_at", label: "زمان شروع" },
        { key: "unavailable_at", label: "زمان پایان" },
        { key: "final_amount", label: "قیمت دوره (تومان)" },
        { key: "course_count", label: "تعداد دوره" },
        { key: "status", label: "وضعیت" },
        { key: "actions", label: "عملیات" },
      ],
    };
  },
  watch: {
    selectAll: {
      handler(val) {
        val
          ? (this.removeSemestersData = this.semesters.map(
              (semester) => semester.id
            ))
          : (this.removeSemestersData = []);
      },
      immediate: true,
    },
    removeSemestersData: {
      handler(val) {
        val.length == this.semesters.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    $route: {
      handler(val) {
        this.removeSemestersData = [];
        this.getSemesters();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "semesters",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: "semesters",
        });
      }
    },
  },
  async created() {
    if (this.$route.query.key) {
      this.$router.push({
        name: "semesters",
      });
    }
    this.url = `/panel/semesters`;
    await this.getSemesters();
  },
  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "semesters",
          query: {
            key: this.search,
          },
        });
      }
    },
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }

      return finalAmount > 0
        ? this.decodePersianName(String(parseInt(finalAmount)))
        : "0";
    },
    removeSemester(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید این ترم حذف شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/semesters/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeSemestersData = [];
                await this.getSemesters();
              } else {
                await this.$router.push({
                  name: "semesters",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "ترم با موفقیت حذف شد.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "مشکلی پیش آمده است",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeSemesters() {
      if (this.removeSemestersData.length) {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید ترم ها انتخاب شده حذف شوند ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await new Promise((resolve, reject) => {
                  this.removeSemestersData.map(async (semester, index) => {
                    await this.$http.delete(`/panel/semesters/${semester}`);
                    if (index + 1 == this.removeSemestersData.length) {
                      resolve();
                    }
                  });
                });
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeSemestersData = [];
                  await this.getSemesters();
                } else {
                  await this.$router.push({
                    name: "semesters",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "ترم ها با موفقیت حذف شدند.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "ترمی انتخاب نشده است",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getSemesters() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
        });
        this.semesters = data.data.semesters;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
